import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift, faClipboard, faCheck } from '@/fontawesome';
import type { PromotionConfig } from '@/modelsLocal/promotion-modal';

interface PromotionBannerProps {
  config: PromotionConfig;
}

export default function PromotionBanner({ config }: PromotionBannerProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(config.couponCode).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="mt-8 max-w-xl mx-auto bg-linear-to-r from-blue-50 to-purple-50 dark:from-blue-900/30 dark:to-purple-900/30 rounded-xl p-6 border border-blue-200 dark:border-blue-800">
      <div className="flex items-center gap-4">
        <img
          src={config.imageUrl}
          alt={config.title}
          className="min-w-16 max-w-24 rounded-lg object-contain shrink"
        />
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <FontAwesomeIcon icon={faGift} className="w-4 h-4 text-blue-600 dark:text-blue-400" />
            <h3 className="font-bold text-gray-900 dark:text-white">{config.title}</h3>
          </div>
          <p className="text-sm text-gray-700 dark:text-gray-300 mb-3">
            {config.shortDescription}
          </p>
          <div className="flex items-center gap-2 bg-white dark:bg-gray-800 rounded-lg p-2">
            <span className="flex-1 font-mono font-bold text-gray-900 dark:text-white tracking-widest text-sm">
              {config.couponCode}
            </span>
            <button
              onClick={handleCopy}
              className="flex items-center gap-1.5 px-3 py-1.5 text-xs bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white rounded-md transition-colors cursor-pointer font-medium"
            >
              <FontAwesomeIcon icon={copied ? faCheck : faClipboard} className="w-3 h-3" />
              {copied ? 'Kopiert!' : 'Kopieren'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
